import { COMMON_COLUMNS, type DrilldownColumn } from '../drilldown-columns-shared';

/**
 * Drill-down columns for the Pipeline tile (owner 2026-10-28): one row per open
 * deal. Deals carry no document number, so the record link sits on the deal
 * name (`COMMON_COLUMNS.title`) and there is no Number column. The deal's stage
 * is its own column (`row.stage`); the shared `status` column is left out
 * because for a deal it would repeat the stage. `date` is the closing date the
 * tile windows on; `amount` is the deal value (deal lines carry no tax).
 */

/** The deal's stage name (display only, never used for logic). */
export const STAGE_COLUMN: DrilldownColumn = {
  key: 'stage',
  label: 'Stage',
  get: (row) => row.stage ?? row.status,
  filter: 'options',
};

export const PIPELINE_COLUMNS: DrilldownColumn[] = [
  { ...COMMON_COLUMNS.title, label: 'Deal' },
  COMMON_COLUMNS.company,
  COMMON_COLUMNS.projects,
  COMMON_COLUMNS.accountLead,
  STAGE_COLUMN,
  { ...COMMON_COLUMNS.date, label: 'Closing date' },
  COMMON_COLUMNS.billingRegion,
  COMMON_COLUMNS.currency,
  { ...COMMON_COLUMNS.amount, label: 'Value' },
  COMMON_COLUMNS.convertedAmount,
];
